import { render } from "./UsersRolesPanel.vue?vue&type=template&id=393fffb6&scoped=true&ts=true&lang=pug"
import script from "./UsersRolesPanel.vue?vue&type=script&lang=ts"
export * from "./UsersRolesPanel.vue?vue&type=script&lang=ts"

import "./UsersRolesPanel.vue?vue&type=style&index=0&id=393fffb6&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-393fffb6"]])

export default __exports__